import React, { useEffect, useState } from "react";
import { Button, Card, Tag, Table, Modal } from "antd";
import {
    PlusOutlined,
    ArrowRightOutlined,
    EyeOutlined,
    FileTextOutlined,
    AppstoreOutlined,
} from "@ant-design/icons";

import "./nuJobsEmployerDashboard.scss";
import useNuJobDetailsStore from "../../store/nujobsdetails.store";
import { useNavigate } from "react-router-dom";
import useMembersStore from "../../store/members.store";

const NuJobsEmployerDashboard = () => {

  const {
        nuJobsEmployerDashboardGetStats,
        employerTotalJDs,
        employerTotalActiveJDs,
        employerTotalEvents,
        employerTotalApplications,
        employerTotalRecentApplications,
        employerRecentJDs,
        employerApplicationsPerJD,
        employerGraphData,
        nuJobsGetEmployerGraphData,
        employerTotalUpcomingEvents
    } = useNuJobDetailsStore();    
    
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const navigate = useNavigate();

  const [maxApplications, setMaxApplications] = useState(1);
  const [subscriptionIsActive, setSubscriptionIsActive] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {  currSubscription, checkSubscriptions } = useMembersStore();
    
const checkSub =(cSubData) =>{
    
    if(userDetails?.permission === "superuser" ||
                     cSubData === "trial_active" || cSubData === "subscription_active"){
       setSubscriptionIsActive(true)
       setIsModalOpen(false)
    }else{
         setSubscriptionIsActive(false)
         setIsModalOpen(true)
    }
  }
  useEffect(() => {
        
        checkSubscriptions(checkSub);
        // Fetch employer dashboard stats from the backend
        nuJobsEmployerDashboardGetStats(userDetails.qhoid, userDetails.qhuid  );
        nuJobsGetEmployerGraphData(userDetails.qhoid, userDetails.qhuid,60*24)
    }, []);

    useEffect(() => {
        if((employerGraphData !== undefined) && (employerGraphData !== null) &&(employerGraphData?.length >0)){
            setMaxApplications(Math.max(...employerGraphData?.map((item) => item. Count), 1));
        }
    }, [employerGraphData]);

   
  
 const showModal = () => {
        setIsModalOpen(true);
      };
 const handleOk = () => {
        setIsModalOpen(false);
      };
 const handleCancel = () => {
        setIsModalOpen(false);
      };   
 
  const formatGraphDate = (dateString) => {
        const date = new Date(`${dateString}T00:00:00`);

        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
        });
    };
    const summaryData = [
        {
            title: "Total Jobs",
            value: employerTotalJDs,
            className: "total-jobs",
        },
        {
            title: "Active Jobs",
            value: employerTotalActiveJDs,
            className: "active-jobs",
        },
        {
            title: "Applications",
            value: employerTotalApplications,
            className: "applications",
        },
        {
            title: "New Applications",
            value: employerTotalRecentApplications,
            className: "new-applications",
        },
        {
            title: "Total Events",
            value: employerTotalEvents,
            className: "total-jobs",
        },
        {
            title: "Upcoming Events",
            value: employerTotalUpcomingEvents,
            className: "active-jobs",
        },        
    ];

    const recentJobs = employerRecentJDs?.map((job, index) => ({
        key: index.toString(),
        title: job.jdtitle,
        qhcompanyjid:job.qhcompanyjid,
        status: job.jdstatus.charAt(0).toUpperCase() + job.jdstatus.slice(1).toLowerCase(),
        applications: job.applicationcount || 0,
    }));
    
    const recentJobss = [
        {
            key: "1",
            title: "Senior React Developer",
            status: "Active",
            applications: 32,
        },
        {
            key: "2",
            title: "Java Developer",
            status: "Active",
            applications: 18,
        },
        {
            key: "3",
            title: "Python Developer",
            status: "Closed",
            applications: 47,
        },
        {
            key: "4",
            title: "UI/UX Designer",
            status: "Active",
            applications: 12,
        },
    ];

    const recentApplications = employerApplicationsPerJD?.map((application, index) => ({
        key: index.toString(),
        candidate: application.name,   
        job: application.jdtitle,  
        applied: application.timestamp ? new Date(application.timestamp*1000).toLocaleDateString() : "N/A",
    }));
    const recentApplicationss = [
        {
            key: "1",
            candidate: "Rahul Sharma",
            job: "React Developer",
            applied: "Today",
        },
        {
            key: "2",
            candidate: "Priya Patil",
            job: "Java Developer",
            applied: "Today",
        },
        {
            key: "3",
            candidate: "Amit Kumar",
            job: "Python Developer",
            applied: "Yesterday",
        },
        {
            key: "4",
            candidate: "Sneha Joshi",
            job: "UI/UX Designer",
            applied: "Yesterday",
        },
    ];

    const handleJDClick = (qhcompanyjid) => {
        navigate(`/nujobposts/${qhcompanyjid}/nujobs`);
    };

    const jobColumns = [
        {
            title: "Job Title",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Job ID",
            dataIndex: "qhcompanyjid",
            key: "qhcompanyjid",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <Tag color={status === "Active" ? "green" : "default"}>
                    {status}
                </Tag>
            ),
        },
        {
            title: "Applications",
            dataIndex: "applications",
            key: "applications",
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <div className="job-actions">
                    <Button
                        type="text"
                        icon={<EyeOutlined />}
                        title="View"
                        onClick={()=>handleJDClick(record.qhcompanyjid)}
                    />
                </div>
            ),
        },
    ];

    const applicationColumns = [
        {
            title: "Candidate",
            dataIndex: "candidate",
            key: "candidate",
        },
        {
            title: "Job",
            dataIndex: "job",
            key: "job",
        },
        {
            title: "Applied",
            dataIndex: "applied",
            key: "applied",
        },
    ];
    const getCurrentSubscription = () => {  
        if(currSubscription === "trial_inactive"){return "VERIFICATION PENDING"}
        if(currSubscription === "trial_active"){return "ACTIVE"}
        if(currSubscription === "trial_expired"){return "EXPIRED"}   
        if(currSubscription === "trial_stop"){return "STOP"}
        if(currSubscription === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}
        if(currSubscription === "trial_expired"){return "EXPIRED"}     
        if(currSubscription === "subscription_inactive"){return "INACTIVE"}
        if(currSubscription === "subscription_new_req"){return "NEW REQ "}
        if(currSubscription === "subscription_configured"){return "CONFIGURED"}
        if(currSubscription === "subscription_active"){return "ACTIVE"}
        if(currSubscription === "subscription_expired"){return "EXPIRED"}
        if(currSubscription === "subscription_stopped"){return "STOPPED"} 
        if(currSubscription === "subscription_aborted"){return "ABORTED"} 
        if(currSubscription === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}        
    }
    return (
        <div className="nujobs-employer-dashboard-wrapper">

            {/* Header */}
            <div className="dashboard-header">

            <div className="dashboard-header-content">
                <div className="dashboard-title-row">
                    <h2>Employer Dashboard</h2>

                    <span
                        className={`subscription-status-badge ${
                            subscriptionIsActive ? "active" : "inactive"
                        }`}
                    >
                         {getCurrentSubscription()}
                    </span>
                </div>

                <p>Manage your jobs, applications and hiring activity</p>
            </div>

                <Button
                    disabled={!subscriptionIsActive}
                    type="primary"
                    icon={<PlusOutlined />}
                    className="post-job-button"
                    onClick={() => {  navigate(`/nujobscreateJd`); }}
                    
                >
                    Post a New Job
                </Button>

            </div>


            {/* Summary Cards */}
            <div className="dashboard-summary-wrapper">

                {summaryData?.map((item) => (
                    <Card
                        key={item.title}
                        className={`summary-card ${item.className}`}
                    >
                        <div className="summary-card-content">

                            <span className="summary-card-title">
                                {item.title}
                            </span>

                            <span className="summary-card-value">
                                {item.value}
                            </span>

                        </div>
                    </Card>
                ))}

            </div>


            {/* Recent Jobs */}
            <div className="dashboard-section">

                <div className="section-header">

                    <div>
                        <h3>Recent Jobs</h3>
                        <p>
                            Your recently posted jobs
                        </p>
                    </div>

                    <Button
                        type="link"
                        icon={<ArrowRightOutlined />}
                        iconPosition="end"
                        onClick={() => { navigate("/nujobposts"); }}
                    >
                        View All
                    </Button>

                </div>

                <Card className="dashboard-table-card">

                    <Table
                        columns={jobColumns}
                        dataSource={recentJobs?.slice(0, 5)}
                        pagination={false}
                        scroll={{ x: 600 }}
                    />

                </Card>

            </div>


            {/* Analytics */}
            <div className="dashboard-section">

                <div className="section-header">

                    <div>
                        <h3>Applications</h3>

                        <p>
                            Applications received over the last 30 days
                        </p>
                    </div>

                </div>

                <Card className="applications-chart-card">

                    <div className="applications-chart">

                        <div className="chart-placeholder">
                            <div className="chart-bars">
                                {employerGraphData?.map((item, index) => {

                                    const height =
                                        (item?.count / maxApplications);

                                    return (
                                        <div
                                            key={index}
                                            className="chart-bar"
                                            style={{
                                                height: `${height}%`,
                                            }}
                                            title={`${item?.date}: ${item?.count} applications`}
                                        />
                                    );
                                })}
                            </div>

                            <div className="chart-labels">
                                {employerGraphData?.map((item, index) => (
                                    <span key={index}>
                                        {formatGraphDate(item?.date)}
                                    </span>
                                ))}
                                {employerGraphData?.length == 0 || employerGraphData === null?
                                  <>No Applications yet</>
                                  :<></>}
                            </div>
                        </div>

                    </div>

                </Card>
            </div>


            {/* Bottom Section */}
            <div className="dashboard-bottom-wrapper">

                {/* Recent Applications */}
                <div className="dashboard-section recent-applications-section">

                    <div className="section-header">

                        <div>
                            <h3>Recent Applications</h3>

                            <p>
                                Latest applications received
                            </p>
                        </div>

                        <Button
                            type="link"
                            icon={<ArrowRightOutlined />}
                            iconPosition="end"
                            onClick={() => { navigate("/nujobsapplications"); }}
                        >
                            View All
                        </Button>

                    </div>

                    <Card className="dashboard-table-card">

                        <Table
                            columns={applicationColumns}
                            dataSource={recentApplications?.slice(0, 5)}
                            pagination={false}
                            scroll={{ x: 500 }}
                        />

                    </Card>

                </div>


                {/* Quick Actions */}
                <div className="dashboard-section quick-actions-section">

                    <div className="section-header">

                        <div>
                            <h3>Quick Actions</h3>

                            <p>
                                Frequently used actions
                            </p>
                        </div>

                    </div>

                    <Card className="quick-actions-card">

                        <Button
                            className="quick-action-button"
                            icon={<PlusOutlined />}
                            onClick={() => {  navigate(`/createJd`); }}
                               
                        >
                            Post a New Job
                        </Button>

                        <Button
                            className="quick-action-button"
                            icon={<AppstoreOutlined />}
                            onClick={() => { navigate("/nujobposts"); }}
                        >
                            Manage My Jobs
                        </Button>

                        <Button
                            className="quick-action-button"
                            icon={<FileTextOutlined />}
                            onClick={() => { navigate("/nujobsapplications"); }}
                        >
                            View Applications
                        </Button>

                    </Card>

                </div>

            </div>

            <Modal title= {"Subscription Status" } open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <div style={{ margin: "10px" }}>
                            <p>Kindly Renew subscription or Wait for Subscription Activation</p>
                    </div>                    
            </Modal>
        </div>
    );
};

export default NuJobsEmployerDashboard;